import { Button } from "devextreme-react";
import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import moment from "moment";
import { forwardRef } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";

import { renderInformationItem } from "../productRequestPage/detail";
import { AccountCallLog } from "./type";

export const AccountCallLogsDetail = forwardRef<any, { data: AccountCallLog }>((
    { data }, ref
) => {
    const localize = useSelector(getLocalized);
    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <GroupItem colCount={2}>
                <SimpleItem
                    dataField={"Account.AccountName"}
                    label={{
                        text: localize.getString("accountName")
                    }}
                    render={renderInformationItem}
                >

                </SimpleItem>
                <SimpleItem>
                    <Button icon="arrowright" onClick={() => {
                        window.open(`/#/account-details/${data.AccountId}`)
                    }}></Button>
                </SimpleItem>
            </GroupItem>
            <SimpleItem
                dataField={"TalkedWith"}
                label={{
                    text: localize.getString("talkedWidth")
                }}
                render={renderInformationItem}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"AccountCallLogStatus"}
                label={{
                    text: localize.getString("callStatus")
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
                dataField={"Note"}
                label={{
                    text: localize.getString("note")
                }}
                render={renderInformationItem}
            >

            </SimpleItem>


            <SimpleItem
                dataField={"NextCallDate"}
                label={{
                    text: localize.getString("nextCallDate")
                }}
                editorType="dxDateBox"
                editorOptions={{
                    dateSerializationFormat: "yyyy-MM-dd"
                }}
                render={
                    (item: any) => {
                        if (item.editorOptions.value !== null) {
                            return <span>{moment.utc(item.editorOptions.value).format("l")}</span>;
                        } else {
                            return <span>-</span>;
                        }
                    }
                }
            >

            </SimpleItem>
            <SimpleItem
                dataField={"NextCallNote"}
                label={{
                    text: localize.getString("nextCallNote")
                }}
                render={renderInformationItem}
            >

            </SimpleItem>


        </GroupItem>

    </Form>
})